module.exports = __webpack_public_path__ + "static/media/number-item-0.a94f26c5.png";